import { MessageSmileModal } from '@/components/modules/message-smile-modal';
import { useAppDispatch } from '@/store/hooks';
import { showModal } from '@/store/reducers/modal/slice';

import { useTranslate } from '@/shared/hooks/use-translate';

export const useRequisitesDialog = () => {
    const dispatch = useAppDispatch();
    const { t } = useTranslate();

    const showRequisitesFailure = (onClose?: () => void) => {
        dispatch(
            showModal({
                content: (
                    <MessageSmileModal
                        textBtn="Понятно"
                        content={t(
                            'К сожалению, оплата онлайн временно недоступна в связи с техническими проблемами. Для оплаты вы можете пройти в отделение.',
                        )}
                        {...(onClose && { onClick: onClose })}
                    />
                ),
                title: t('Не удалось провести оплату'),
                ...(onClose && { onClose }),
            }),
        );
    };

    return {
        showRequisitesFailure,
    };
};
